import type { UpsertPhaseLabelRequest, UpsertPhaseLabelResponse } from '@vy/api-definition';
import { UpsertPhaseLabelResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useUpsertPhaseLabel(
  options?: UseMutationOptions<UpsertPhaseLabelResponse, unknown, UpsertPhaseLabelRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (upsertPhaseLabelRequest) => {
      const api = getPrivateApi();
      const upsertPhaseLabelResponse = await api.upsertPhaseLabel({
        upsertPhaseLabelRequest,
      });

      return UpsertPhaseLabelResponseSchema.parse(upsertPhaseLabelResponse);
    },
    {
      onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.phaseLabels() }),
      ...options,
    },
  );
}
